import '../assets/styles/aero-loader.css';

export default function AeroLoader() {
  return (
    <div id="aero-loader-overlay">
      <div className="aero-honeycomb">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <div className="aero-loader-label">Loading...</div>
    </div>
  );
}
